<div class="row">
  @if (defaultHeader()) {
    <div class="col-12 fw-bold h5 mb-2 mt-3">
      Daten
      <hr class="m-0 p-0">
    </div>
  }
  @for (field of (process()?.fields ?? []); track field.id; let i = $index) {
    <div class="col-md-{{field.formField?.type === FieldType.HEADER || field.formField?.type === FieldType.SEPARATOR_LINE || field.formField?.type === FieldType.TABLE || field.formField?.type === FieldType.SELECTION_TABLE ? '12' : field.formField?.columnWidth}} mb-2">
      <div class="pb-3 pt-2 h-100" [ngSwitch]="field.formField?.type">
        @switch (field.formField?.type) {
          @case (FieldType.HEADER) {
            <span class="fw-bold h5" [innerHTML]="processStyleMarkupWithoutBreaks(field.formField?.name)"></span>
            <hr class="m-0 p-0">
          }
          @case (FieldType.SEPARATOR_LINE) {
            <hr class="m-0 p-0">
          }
          @case (FieldType.DESCRIPTION) {
            @if (!onlyRelevanteFields()) {
              <div [innerHTML]="processStyleMarkup(field.formField?.fieldCustomParameter.value)"></div>
            }
          }
          @case (FieldType.BLANK_SPACE) {
          }
          @case (FieldType.FILE) {
            <label class="form-label text-secondary fw-bold" [innerHTML]="processStyleMarkupWithoutBreaks(field.formField?.name)"></label>
            <ul>
              @for (file of parseJson(field.content); track file; let j = $index) {
                <li>
                  @let filename = leadingZero(i + 1) + leadingZero(j + 1) + '_' + file.name;
                  <a class="text-underline pointer"
                     (click)="openFile(filename, file.mimeType, file.data)"
                     (keydown.enter)="openFile(filename, file.mimeType, file.data)"
                     (keydown.space)="openFile(filename, file.mimeType, file.data)"
                     tabindex="0">{{file.name}}</a>
                </li>
              }
            </ul>
          }
          @default {
            <label class="form-label text-secondary fw-bold" [innerHTML]="processStyleMarkupWithoutBreaks(field.formField?.name)"></label>
            <div>
              <span [innerHTML]="contentToHTML(field)"></span>
              @if (process()?.operator && (process()?.actionType === ActionType.OTRS || process()?.actionType === ActionType.OTRS_WEBSERVICE) && field.formField?.type === FieldType.CLIENT && field.content) {
                <a href="https://tools.rbb-online.de/clientmanagement/management/clients/{{field.content}}/home" target="_blank"><i class="fas fa-external-link-alt d-inline-block ms-1"></i></a>
              }
            </div>
          }
        }
      </div>
    </div>
  }
</div>
